<script>
import lazyLoadComponent from '@router/lazyload-component'
import BaseButtonDialog from '@components/BaseButtonDialog'
import { cloneDeep } from 'lodash'
import { currentQuestionList } from '@utils/pet-question'
import petQ from '@src/mixins/petQ'

const initDefaultSubmitData = {
  questions: (alias) => {
    const defaultQuestions = currentQuestionList(alias) || {}
    const stringFields = ['marriage', 'homeAddress', 'workingAddress', 'email', 'latestVaccineDate']
    return Object.fromEntries(
      Object.keys(defaultQuestions).map((key) => {
        const value = stringFields.includes(key) ? '' : []
        return [key, value]
      })
    )
  },
}

export default {
  components: {
    BaseButtonDialog,
    BaseUpload: () => lazyLoadComponent(import('@components/BaseUpload')),
    PetForm: () => lazyLoadComponent(import('@components/PetForm')),
    PetCommentList: () => lazyLoadComponent(import('@components/PetCommentList')),
  },
  mixins: [petQ],
  props: {
    defaultValue: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      // pets: Array.from({ length: 5 }).fill(pet),
      // pet,
      questions: {},
      petList: [],
      dialogItem: {},
      submitData: {},
      // behavior:[],
      // healthy:[],
      defaultSinglePetData: {},
      dialogMode: 'edit', // edit 編輯, add 新增， view 預覽
      // typeList,
      // bodyTypeList,
      // gender,
      dialogVisible: false,
      showDetail: false,
      category: [],
      // parentCategoryId: '',
      parentCategoryIndex: 0,
      tryingGet: false,

      tryingToSave: false,
      currentType: '',
      editDetailEnabled: false,
      activeTab: '0',
      tabList: Object.freeze([
        {
          title: `${this.$t('reserve.CLIENT')}資訊`,
          component: () => import('./DetailPetsInfo'),
        },
        {
          title: '訂單紀錄',
          component: () => import('./DetailPetsOrders'),
        },
        {
          title: '服務紀錄',
          component: () => import('./DetailPetsNotice'),
        },
      ]),
    }
  },
  computed: {
    imgRoute() {
      if (this.$appType() === 'ipetbooking') {
        return require('@assets/images/pet-avatar-default@2x.png')
      } else {
        return require('@assets/images/person_background.svg')
      }
    },
    currentStoreAlias() {
      return this.$store.state.merchant.cached.alias
    },
  },
  created() {
    this.tryToFetchList()
    this.tryToFetchCategory()
    this.initDefaultQuestions()
  },
  methods: {
    async tryToFetchCategory() {
      this.category = await this.$store.dispatch('product/fetchServiceCategory', { paginate: 0 })
    },
    async tryToFetchList() {
      this.petList = await this.$store.dispatch('member/fetchPetList', {
        memberId: this.$route.params.memberId,
      })
    },
    async gotoSinglePet(row, column, cell) {
      this.showDetail = true
      this.tryToFetchSinglePet(row.id)
    },
    async tryToFetchSinglePet(id) {
      this.tryingGet = true
      const { items } = await this.$store.dispatch('member/fetchSinglePet', {
        memberId: this.$route.params.memberId,
        petId: id,
      })
      this.submitData = items
      this.defaultSinglePetData = cloneDeep(items)
      this.setDefaultQuestion()
      this.tryingGet = false
    },
    setDefaultQuestion() {
      const { behavior, healthy } = this.submitData.questions
      if (healthy && this.questions.healthy) {
        this.questions.healthy.forEach((item) => {
          const res = healthy.find((i) => {
            return i.title === item.title
          })
          item.text = res ? res.text : ''
        })
      }
      if (behavior && this.questions.behavior) {
        this.questions.behavior.forEach((item) => {
          const res = behavior.find((i) => {
            return i.title === item.title
          })
          item.text = res ? res.text : ''
        })
      }
    },
    openDialog(mode, itemData) {
      this.behavior = []
      this.healthy = []
      this.questions.behavior.forEach((item) => {
        item.text = ''
      })
      this.questions.healthy.forEach((item) => {
        item.text = ''
      })
      this.dialogVisible = true
      this.dialogMode = mode
      this.$set(this.$data, 'dialogItem', itemData)
    },
    closeDialog() {
      this.dialogVisible = false
      this.tryToFetchList()
    },
    async tryToRemove(id) {
      await this.$confirm(`確定刪除該${this.$t('reserve.CLIENT')}？`, '警告', {
        confirmButtonText: '確定',
        cancelButtonText: '取消',
        type: 'warning',
        center: true,
      })
      try {
        await this.$store.dispatch('member/removehPet', {
          memberId: this.$route.params.memberId,
          ids: [id],
        })
        this.tryToFetchList()
      } finally {
      }
    },
    enableEditDetail(val) {
      this.currentType = val.type
      this.editDetailEnabled = val.isEditEnabled
    },
    async tryToSave() {
      try {
        this.tryingToSave = true

        if (this.submitData.questions && Object.keys(this.submitData.questions).length) {
          this.targetMappingArray.forEach((property) => {
            this.submitData.questions[property] = this.forEachToSubmitData(this.submitData.questions[property], property)
          })
        }

        await this.$store
          .dispatch('member/storeSinglePet', this.submitData)
          .then(() => {
            this.cancelEdit()
            this.tryToFetchSinglePet(this.submitData.id)
            this.editDetailEnabled = false
          })
          .finally(() => {
            this.tryingToSave = false
          })
      } catch (error) {
        console.error(error.message)
      }
    },
    /**
     * @description 將陣列放進去submitData內
     */
    forEachToSubmitData(value, key) {
      try {
        if (!value) {
          return []
        }

        if (Array.isArray(value)) {
          value.forEach((item) => {
            if (typeof item === 'object' && !Array.isArray(item)) {
              const res = this.questions[key].find((question) => {
                return item.title === question.title
              })
              item.text = res ? res.text : ''
            }
          })
        }

        return value
      } catch (error) {
        console.error(error.message)
      }
    },
    backToList() {
      this.showDetail = false
      this.cancel()
      this.tryToFetchList()
      this.activeTab = '0'
    },
    getParentCategoryIndex() {
      this.category.forEach((item, index) => {
        if (this.submitData.categoryId === item.id) {
          this.parentCategoryIndex = index
        }
      })
    },
    changeCategory() {
      this.submitData.sizeId = ''
    },
    cancelEdit() {
      const currentTab = `step${this.activeTab}`
      this.$refs[currentTab].editDetailEnabled = false
      this.editDetailEnabled = false
    },
    cancel() {
      this.editDetailEnabled = false
      this.submitData = cloneDeep(this.defaultSinglePetData)
      this.questions = cloneDeep(currentQuestionList(this.currentStoreAlias))
      this.cancelEdit()
    },
    async saveEdit() {
      await this.tryToSave()
    },
    onInputQuestions(val) {},
    showDialogVisible() {
      this.dialogVisible = true
      this.submitData = initDefaultSubmitData.questions(this.currentStoreAlias)
    },
    updatePetInfo() {
      this.tryToFetchSinglePet(this.submitData.id)
    },
    initDefaultQuestions() {
      this.questions = cloneDeep(currentQuestionList(this.currentStoreAlias))
      this.submitData.questions = initDefaultSubmitData.questions(this.currentStoreAlias)
    },
    updatePetQuestions(val) {
      this.submitData.petQuestions = val
    },
  },
}
</script>

<template>
  <div>
    <!-- <keep-alive> -->
    <div v-if="!showDetail" :class="$style.DetailPets">
      <BasePageHeader :title="`${$t('reserve.CLIENT')}管理`">
        <template v-slot:right>
          <el-button v-if="!showDetail" class="is-round" type="primary" @click="showDialogVisible">
            <BaseIcon name="plus" />
            <span>新增</span>
          </el-button>
        </template>
      </BasePageHeader>
      <div class="el-table-wrapper">
        <div @click.stop>
          <el-table :data="petList" :element-loading-text="`取得${$t('reserve.CLIENT')}資訊中`" class="isBgDark" @row-click="gotoSinglePet">
            <el-table-column v-slot="{ row }" :label="`${$t('reserve.CLIENT')}頭像`" width="140" align="center">
              <div :class="$style.petListImg">
                <img v-if="row.avatar" :src="row.avatar" alt="" height="70" />
                <img v-else :src="imgRoute" alt="" height="70" />
              </div>
            </el-table-column>
            <el-table-column prop="name" :label="`${$t('reserve.CLIENT')}名字`" :min-width="12"> </el-table-column>
            <el-table-column prop="categoryTitle" :label="`${$t('member.KIND_TO_CATEGORY')}`" :min-width="8"> </el-table-column>
            <el-table-column prop="sizeTitle" :label="`${$t('member.BODY_TO_TYPE')}`" :min-width="12"> </el-table-column>
            <el-table-column v-slot="{ row }" width="65" @click.stop>
              <el-dropdown :hide-on-click="false" trigger="click">
                <span class="el-dropdown-link p-3" @click.stop>
                  <BaseIcon name="ellipsis-h" />
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item @click.native.stop="gotoSinglePet(row)">
                    <span>
                      <BaseIcon name="edit" />
                      編輯
                    </span>
                  </el-dropdown-item>
                  <el-dropdown-item @click.native.stop="tryToRemove(row.id)">
                    <span>
                      <BaseIcon name="trash-alt" />
                      刪除
                    </span>
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </el-table-column>
          </el-table>
        </div>
      </div>
    </div>
    <!-- </keep-alive> -->
    <template v-else>
      <el-tabs v-model="activeTab" type="border-card" stretch class="isStyleBase" :before-leave="cancel">
        <el-tab-pane v-for="(tab, index) in tabList" :key="index" :label="tab.title" :name="`${index}`"> </el-tab-pane>
      </el-tabs>
      <component
        :is="tabList[activeTab].component"
        :ref="`step${activeTab}`"
        v-model="submitData"
        :class="[{ [$style.pageContent]: tabList[activeTab].title !== '訂單紀錄' }]"
        :default-questions="questions"
        :default-value="defaultSinglePetData"
        @inputQuestions="onInputQuestions"
        @updatePetQuestions="updatePetQuestions"
        @back="backToList"
        @isEditDetailEnabled="enableEditDetail"
        @update="updatePetInfo"
      />
      <div v-if="editDetailEnabled" :class="$style.footer">
        <el-button class="is-round" :loading="tryingToSave" @click="cancel">取消編輯</el-button>
        <el-button class="is-round" type="primary" :loading="tryingToSave" @click="saveEdit">儲存編輯</el-button>
      </div>
    </template>

    <BaseButtonDialog :title="`${$t('reserve.CLIENT')}資料`" only-dialog :dialog-visible.sync="dialogVisible" floating destroy @opened="openDialog('add')">
      <PetForm :default-value="defaultValue" :category="category" :current-store-alias="currentStoreAlias" @close="closeDialog" />
    </BaseButtonDialog>
  </div>
</template>

<style lang="scss" module>
@import '@design';
@import '@src/design/layout_detail_steps.scss';

.DetailPets {
  padding: 1.68rem 1rem 0;

  @include max-md {
    padding: 1rem 1rem 0;
  }
}

.petListImg {
  border-radius: 100%;
  overflow: hidden;
  height: 70px;
  width: 70px;
}

.pet {
  // font-size: 18px;
  :global {
    .danger {
      color: $color-state-danger;
    }

    .top {
      margin-bottom: 20px;
      display: flex;
      justify-content: space-between;
    }

    .pet {
      &__back {
        cursor: pointer;
      }

      &__box {
        margin-bottom: 30px;
      }

      &__info {
        &__list {
        }

        &__item {
          margin-bottom: 18px;
        }
      }
    }

    .notice {
      margin-bottom: 30px;

      h5 {
        font-size: 18px;
      }

      line-height: 1.5;
    }
  }
}
</style>
